import React from 'react'

const Header = () => {
    return (
        // Ḥeader Section
        <div className='flex flex-col justify-center items-center'>
            <span className="text-[32px] font-bold text-center mb-3">Top crypto exchanges</span>
            <span className="text-[20px] font-semibold text-center text-gray-500 ">Compare all 190 crypto exchanges. The list is ranked by trading volume.</span>
        </div>
    )
}

export default Header;